
export const DI = {
  // Instrumentation
  IInstrumentationService: Symbol.for('IInstrumentationService'),
  IErrorReporter: Symbol.for('IErrorReporter'),

  // Data
  StorageAdapter: Symbol.for('StorageAdapter'),

  // API
  IApiClientService: Symbol.for('IApiClientService'),
  IApiClientServiceFactory: Symbol.for('IApiClientServiceFactory'),
  IEndpointResolver: Symbol.for('IEndpointResolver'),
  IApiRequestBuilder: Symbol.for('IApiRequestBuilder'),
  IApiResponseHandler: Symbol.for('IApiResponseHandler'),

  // Request context
  IClientIpResolver: Symbol.for('IClientIpResolver'),

  // Page data
  PageStoreFactory: Symbol.for('PageStoreFactory'),
  LoadPageDataUseCaseInterface: Symbol.for('LoadPageDataUseCaseInterface'),
  GetPageMetaUseCase: Symbol.for('GetPageMetaUseCase'),
  PageParamsToSendResolverInterface: Symbol.for('PageParamsToSendResolverInterface'),
  PageParamsOnFunctionsResolverInterface: Symbol.for('PageParamsOnFunctionsResolverInterface'),
  PageParamsFunctionsRegistry: Symbol.for('PageParamsFunctionsRegistry'),
  FetchOptionsFactory: Symbol.for('FetchOptionsFactory'),
  PageOptionsFactory: Symbol.for('PageOptionsFactory'),

  // Analytic
  PulseAnalytics: Symbol.for('PulseAnalytics'),
  MindboxAnalytics: Symbol.for('MindboxAnalytics'),

  // Login
  ThirdPartyOAuthComponentFactory: Symbol.for('ThirdPartyOAuthComponentFactory'),

  // Product list
  ProductListItemViewModelFactory: Symbol.for('ProductListItemViewModelFactory'),
  CatalogProductListViewModelFactory: Symbol.for('CatalogProductListViewModelFactory'),

  // Favourite
  FavouriteRepositoryInterface: Symbol.for('FavouriteRepositoryInterface'),
  ToggleFavouriteUseCase: Symbol.for('ToggleFavouriteUseCase'),

  // Repositories
  IBasketRepository: Symbol.for('IBasketRepository'),

  // Use Cases - Basket
  AddToBasketUseCase: Symbol.for('AddToBasketUseCase'),
  AddCertificateUseCase: Symbol.for('AddCertificateUseCase'),
  UpdateBasketItemUseCase: Symbol.for('UpdateBasketItemUseCase'),
  RemoveFromBasketUseCase: Symbol.for('RemoveFromBasketUseCase'),
  SyncBasketUseCase: Symbol.for('SyncBasketUseCase'),

  // Use Cases - Order
  CreateOrderUseCase: Symbol.for('CreateOrderUseCase'),
  CalculateOrderTotalsUseCase: Symbol.for('CalculateOrderTotalsUseCase'),

  // Catalog
  // Interfaces
  FiltersViewModel: Symbol.for('FiltersViewModel'),
  FiltersViewModelFactory: Symbol.for('FiltersViewModelFactory'),
  // Use Cases
  TransformFiltersUseCase: Symbol.for('TransformFiltersUseCase'),

  // Presentation Stores
  BasketStoreInterface: Symbol.for('BasketStoreInterface'),
  FavouriteStoreInterface: Symbol.for('FavouriteStoreInterface'),

  // Form testing
  FunctionalTestingRulesServiceInterface: Symbol.for('FunctionalTestingRulesServiceInterface'),

  // Services
  IQueryCacheService: Symbol.for('IQueryCacheService'),
  ILoggerService: Symbol.for('ILoggerService'),
  IEventBus: Symbol.for('IEventBus'),
  CaptchaService: Symbol.for('CaptchaService'),
  SessionServiceInterface: Symbol.for('SessionServiceInterface'),
  SessionManagerInterface: Symbol.for('SessionManagerInterface'),
  INotificationService: Symbol.for('INotificationService'),
  SearchAddressInterface: Symbol.for('SearchAddressInterface'),
  SearchCustomLocationInterface: Symbol.for('SearchCustomLocationInterface'),
  IWebApiProxyService: Symbol.for('IWebApiProxyService'),
  ISessionResponseProcessor: Symbol.for('ISessionResponseProcessor'),
  ICurrentSessionResolver: Symbol.for('ICurrentSessionResolver'),
  ServerCookieAgentInterface: Symbol.for('ServerCookieAgentInterface'),
  ISessionIdentityVerifier: Symbol.for('ISessionIdentityVerifier'),

  // Order Services
  IOrderService: Symbol.for('IOrderService'),
  IDeliveryService: Symbol.for('IDeliveryService'),
  IPaymentService: Symbol.for('IPaymentService'),
  CompanyInfoServiceInterface: Symbol.for('CompanyInfoServiceInterface'),
  IRecipientFormStrategyFactory: Symbol.for('IRecipientFormStrategyFactory'),

  // Server-only
  GetServerSessionUseCase: Symbol.for('GetServerSessionUseCase'),
  CSRFManagerInterface: Symbol.for('CSRFManagerInterface'),
  OAuthApiClientInterface: Symbol.for('OAuthApiClientInterface'),
}

export const DI_VARIATIONS = {
  // Data
  MobileStorage: Symbol.for('MobileStorage'),
  LocalStorage: Symbol.for('LocalStorage'),

  // API
  NextApiEndpointProvider: Symbol.for('NextApiEndpointProvider'),
  ServerWebApiEndpointProvider: Symbol.for('ServerWebApiEndpointProvider'),

  MobileApiRequestBuilder: Symbol.for('MobileApiRequestBuilder'),
  ApiRequestBuilder: Symbol.for('ApiRequestBuilder'),

  ApiResponseHandler: Symbol.for('ApiResponseHandler'),
  MobileApiResponseHandler: Symbol.for('MobileApiResponseHandler'),

  // Page data
  MobileSessionService: Symbol.for('MobileSessionService'),
  WebSessionService: Symbol.for('WebSessionService'),
  WebClientSessionService: Symbol.for('WebClientSessionService'),
  FavouriteFetchOptionsFactoryProxy: Symbol.for('FavouriteFetchOptionsFactoryProxy'),
  LoginFetchOptionsFactoryProxy: Symbol.for('LoginFetchOptionsFactoryProxy'),
  OrderFetchOptionsFactoryProxy: Symbol.for('OrderFetchOptionsFactoryProxy'),
  BasketFetchOptionsFactoryProxy: Symbol.for('BasketFetchOptionsFactoryProxy'),
  ProfileFetchOptionsFactoryProxy: Symbol.for('ProfileFetchOptionsFactoryProxy'),
  CertificatesFetchOptionsFactoryProxy: Symbol.for('CertificatesFetchOptionsFactoryProxy'),
  ProfileRootFetchOptionsFactoryProxy: Symbol.for('ProfileRootFetchOptionsFactoryProxy'),
  ProfileReservationsFetchOptionsFactoryProxy: Symbol.for(
    'ProfileReservationsFetchOptionsFactoryProxy',
  ),
  StaticFetchOptionsFactoryProxy: Symbol.for('StaticFetchOptionsFactoryProxy'),

  // Favourite
  FavouriteRepositoryInterface: Symbol.for('FavouriteRepositoryInterface'),
}
